import { render, staticRenderFns } from "./CardPropertiesMultiField.vue?vue&type=template&id=28c04c97"
import script from "./CardPropertiesMultiField.vue?vue&type=script&lang=js"
export * from "./CardPropertiesMultiField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports